import { render, staticRenderFns } from "./HistoryPublished.vue?vue&type=template&id=99c32748"
import script from "./HistoryPublished.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryPublished.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports